// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"NewYearStory_contentContainer__3oV53","title":"NewYearStory_title__2jP7T","descriptionContainer":"NewYearStory_descriptionContainer__1VhDJ"};